import Keycloak from "keycloak-js";

const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL || "https://valedoamanhecer.app.br/login-control";
const keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM || "devas";
const keycloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "osoec";

const keycloak = new Keycloak({
  url: keycloakUrl,
  realm: keycloakRealm,
  clientId: keycloakClientId,
});

export default keycloak;
